/**
 * Converts newlines to markdown hard breaks by adding double space before each newline.
 * Markdown requires `  \n` (two spaces + newline) to render as a line break (<br>).
 */
export const formatNewlinesForMarkdown = (input: string): string =>
  input.replace(/\n/g, '  \n');
